import { Component, input } from '@angular/core';
import { AppNavigation } from '../../types/navigation.types';
import { NavigationItemComponent } from './item/navigation-item.component';

@Component({
  selector: 'immo-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css',
  imports: [NavigationItemComponent],
})
export class NavigationComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly navigation = input.required<AppNavigation>();

  /**
   * Whether the navigation items are rendered wider with text or only as icons.
   */
  readonly isExpanded = input.required<boolean>();

  readonly withIcons = input<boolean>(true);
}
